//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'
var moment = require('moment-timezone')

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'
import DataSource from "devextreme/data/data_source"
import dxDataGrid from 'devextreme/ui/data_grid'
import 'devextreme/ui/load_indicator'
import 'devextreme/ui/button'
import 'devextreme/ui/select_box'

//#endregion

import { IUserSession } from '../../../helpers/user-session'
import { MeasurementsChartBridge } from '../measurements/chart/chart.directive.controller'
import { MeasurementsController, MeasurementDataType } from '../measurements/measurements.controller'
import { ColumnModel, FieldModel, MeasurementModel, MeasurementsRequestModel, SchemaModel } from '../../api/api.models'
import { CommonHelper } from '../../../helpers/common-helper'
import { OperatorLayoutSettings } from '../../../helpers/operator-layout-settings'
import { GridOptions, GridTypes } from '../grid/grid.controller'
import { EventsNames } from '../../../helpers/events-names'
import { Permissions } from '../../../helpers/permissions'
import { Enums } from '../../../models/common/enums'
import { OpSchema } from '../../../models/custom/op-schema';
import { ConvertHelper } from '../../../helpers/convert-helper';

import { ConfigHelper } from '../../../helpers/config-helper'
import { Dictionary, LocalizationHelper, TemplateHelper } from '../../../helpers'

//#region Asset Imports

import { IMRBaseControlDirectiveController } from '../base'
import { GridDetailsService } from './services/grid-details.service'
import { OpDataType, OpDataTypeInGroup, OpLocation } from '../../../models/core'
import { IMRMXGraphOptions } from '@imr/controls.mxgraph.angularjs'
import { DetailsParametersOptions } from '../details-parameters/details-parameters.directive'
import { GridService } from '../../../services/grid'
import { IReferenceType } from '../../../models/util/interfaces'
import { MeasurementsService } from '../measurements/measurements.service'
import { DetailsCorrelationFilterType, DetailsReferenceType, RowData, Tooltip } from './grid-details.interfaces'
import { DataProviderRequest } from '../../../data-provider'
import { MeasureCollection } from '../../../models/custom'

//#endregion

/**@deprecated use from inerfaces */
export interface GridDetailsSettings {
    objects: any[]

    eventNameForSchemaChanged?: string

    measurmentIdsField: string
    measurmentIdField: string
    // for multiselect
    measurmentIdFields?: string[]
    measurmentIdSaveTo?: string
    measurmentIdsFields?: any | {
        fieldIdName: string,
        objectName: string
    }[]
    // ---    

    filterId: DetailsCorrelationFilterType

    referenceType: Enums.ReferenceType
    noDataText?: string

    moduleName: Enums.SimaxModuleName

    refreshDelegate: () => void
}

interface GridDetailsScope extends ng.IScope {
    /**incoming options */
    settings: GridDetailsSettings

    detailsParametersOptions: DetailsParametersOptions
    referenceObjects: DetailsReferenceType[]

    // details: FieldModel[][]
    gridOptions: GridOptions
    chartBridge: MeasurementsChartBridge
    /**toltips for chart */
    tooltipNames: Tooltip[]
    showLoading: boolean
    schemas: SchemaModel[]
    /**
     * location: Oplocation,
     * schema: string,
     * schemaModel: SchemaModel,
     * visualizationOnly: boolean,
     * frameId: number,
     * scripts: string???,
     * datatypeDict: Dictionary\<OpDataType\>
     */
    schemaOptions: IMRMXGraphOptions
    schemaGalleryOptions: DevExpress.ui.dxGalleryOptions
    showLoadingForChart: boolean

    measurementsTypeSelectBoxOptions: DevExpress.ui.dxSelectBoxOptions
    measurementsTypeSelected: number

    measurementsClearButtonOptions: DevExpress.ui.dxButtonOptions
    measurementsClearButtonVisible: boolean

    schemaOwner: { fields: FieldModel[], id: number, name: string, referenceId: string; } //IReferenceType after chaemas refctoring

    NO_DATA_TEXT: string
    NO_DATA_TO_SHOW_TEXT: string
}

export class GridDetailsController extends IMRBaseControlDirectiveController {

    // Consts 

    private static get LOG_STRING(): string { return '[SIMAX.GridDetails.Directive] - %s' }

    // Consts End 

    public static getOptionsByReferenceType(referenceType: Enums.ReferenceType): GridDetailsSettings {
        switch (referenceType) {
            case Enums.ReferenceType.IdLocation:
                return <GridDetailsSettings>{
                    objects: [],
                    measurmentIdField: "idLocation",
                    measurmentIdFields: ["idLocation", "serialNbr", "idMeter"],
                    measurmentIdsFields: [
                        false, // use measurmentIdsField
                        {
                            fieldIdName: 'deviceIds',
                            objectName: 'devices'
                        },
                        {
                            fieldIdName: 'meterIds',
                            objectName: 'meters'
                        }
                    ],
                    measurmentIdSaveTo: 'locationsShortDetails',
                    measurmentIdsField: "locationIds",
                    eventNameForSchemaChanged: 'schemasInLocationsShortDetails',
                    filterId: DetailsCorrelationFilterType.Location,
                    refreshDelegate: null,
                    referenceType: referenceType,
                    moduleName: Enums.SimaxModuleName.Location
                }
            case Enums.ReferenceType.SerialNbr:
                return <GridDetailsSettings>{
                    objects: [],
                    measurmentIdField: "serialNbr",
                    measurmentIdsField: "deviceIds",
                    filterId: DetailsCorrelationFilterType.Device,
                    refreshDelegate: null,
                    referenceType: referenceType,
                    moduleName: Enums.SimaxModuleName.Device
                }
            case Enums.ReferenceType.IdMeter:
                return <GridDetailsSettings>{
                    objects: [],
                    measurmentIdField: "idMeter",
                    measurmentIdsField: "meterIds",
                    filterId: DetailsCorrelationFilterType.Meter,
                    refreshDelegate: null,
                    referenceType: referenceType,
                    moduleName: Enums.SimaxModuleName.Meter
                }
            case Enums.ReferenceType.IdTask:
                return <GridDetailsSettings>{
                    objects: [],
                    measurmentIdField: "taskId",
                    measurmentIdsField: "locationIds",
                    filterId: DetailsCorrelationFilterType.Location,
                    refreshDelegate: null,
                    referenceType: referenceType,
                    moduleName: Enums.SimaxModuleName.Task
                }
            default:
                return null
        }
    }

    private thresholdTypes: MeasurementDataType[]

    /**idLocation/idMeter/SerialNbr */
    private idReferenceType: number = null

    private grid: dxDataGrid
    private gridId: number
    private gridDeferred: JQueryDeferred<dxDataGrid> = null

    private chartData: MeasurementModel[] = [];
    private updateDetailsTimeout: any// NodeJS.Timer
    private updateGridDetailsTimeout: any// NodeJS.Timer
    private lastIds: number[]
    private measurementsData: MeasureCollection[]
    private getSchemasRequest: DataProviderRequest<OpSchema[]>
    private getMeasurementsRequest: DataProviderRequest<MeasureCollection[]>
    private getReferenceObjectRequest: DataProviderRequest<IReferenceType>

    private refreshMeasuremetsChart: (data: MeasureCollection[]) => void = null
    private callRefreshMeasuremetsFunction: (columns: MeasurementDataType[]) => void = null
    private refreshEvent: () => void = null

    private get gridDetailsName(): string { return 'gridDetails' }

    constructor(
        private $scope: GridDetailsScope,
        private $compile: ng.ICompileService,
        private userSession: IUserSession,
        private gridDetailsService: GridDetailsService,
        private gridService: GridService,
        private measurementService: MeasurementsService
    ) {
        super()

        this.setTemplateConsts()
        this.setEvents()
        this.setThresholdColumns()
        this.setOptions()
    }

    //#region Public methods

    //#endregion

    //#region Private methods

    //#region Events

    private setEvents(): void {
        this.$scope.$watch(() => {
            const chartElement = angular.element('.grid-details .chart')
            return chartElement.width() * chartElement.height()
        }, _.debounce((val) => {
            this.$scope.$broadcast(EventsNames.UPDATE_CHART)
        }, 300))

        this.$scope.$watch('useFilter', val => {
            if (this.$scope.gridOptions != null) {
                this.updateDetails(this.$scope.settings.objects)
            }
        })

        this.$scope.$watchCollection('settings.objects', (objects: RowData[]) => {
            if (_.size(objects) > 0) {
                this.$scope.referenceObjects = _.map(objects, (object: RowData) => this.gridService.getSourceObjectFromGridObject(object, this.$scope.settings.referenceType))
            }

            const ids: number[] = objects.map((obj: RowData) => obj.id)

            if (!_.isEqual(ids, this.lastIds)) {
                this.refresh()
            }

        })

        this.$scope.$on(EventsNames.UPDATE_GRID_DETAILS, () => {
            if (this.updateGridDetailsTimeout != null) {
                clearTimeout(this.updateGridDetailsTimeout)
            }

            this.updateGridDetailsTimeout = setTimeout(() => {
                this.updateGridDimentions()
            }, 200)
        })

        this.$scope.$on(EventsNames.UPDATE_SCHEMAS, () => {
            this.$scope.schemas = []
            this.$scope.schemaGalleryOptions = null

            this.loadSchemas()
        })

        this.$scope.$on(EventsNames.UPDATE_METERS, (event: ng.IAngularEvent, ...args: any[]) => {
            this.updateDetails(this.$scope.settings.objects)
        })

        //#region correlation

        if (_.size(this.$scope.settings.eventNameForSchemaChanged) > 0) {
            this.$scope.$on(EventsNames.SCHEMA_CHANGED + this.$scope.settings.eventNameForSchemaChanged, (event, args) => {
                if (this.refreshMeasuremetsChart != null) {
                    const schema: SchemaModel = args

                    if (schema != null && _.size(this.measurementsData) > 0) {
                        let newData: MeasureCollection[] = []
                        let needUpdate: boolean = false
                        const selectedType: DetailsCorrelationFilterType = this.getSelectedType()

                        if (selectedType == DetailsCorrelationFilterType.Location && schema.referenceType == Enums.ReferenceType.IdLocation) {
                            this.measurementsData.forEach((d: MeasureCollection) => {
                                if (d.idLocation == schema.idObject) {
                                    newData.push(d)
                                }
                            })

                            needUpdate = true
                        } else if (selectedType == DetailsCorrelationFilterType.Device && schema.referenceType == Enums.ReferenceType.SerialNbr) {
                            this.measurementsData.forEach((d: MeasureCollection) => {
                                if (d.serialNbr == schema.idObject) {
                                    newData.push(d)
                                }
                            })

                            needUpdate = true
                        } else if (selectedType == DetailsCorrelationFilterType.Meter && schema.referenceType == Enums.ReferenceType.IdMeter) {
                            this.measurementsData.forEach((d: MeasureCollection) => {
                                if (d.idMeter == schema.idObject) {
                                    newData.push(d)
                                }
                            })

                            needUpdate = true
                        }

                        if (needUpdate) {
                            const actualData: MeasureCollection[] = newData
                            this.$scope.$root.$broadcast('disableLoadingIndicator')
                            this.refreshMeasuremetsChart(actualData)
                            this.$scope.measurementsClearButtonVisible = true
                        }
                    }
                }
            })
        }

        //#endregion

        this.$scope.settings.refreshDelegate = (): void => {
            this.refresh()
        }
    }

    //#endregion


    //#region  Options

    private setOptions(): void {
        this.$scope.schemaOwner = null
        this.$scope.measurementsSchemaChangesClearVisible = false

        this.setMeasurementsClearButtonOptions()
    }

    private setMeasurementsClearButtonOptions(): void {
        this.$scope.measurementsClearButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.CLOSE, this.userSession),
            onClick: (e: any) => {
                this.$scope.$root.$broadcast('disableLoadingIndicator')
                this.refreshMeasuremetsChart(this.measurementsData)
                this.$scope.measurementsSchemaChangesClearVisible = false
            },
            hint: LocalizationHelper.getLocalizedText('ClearSortFromSchemas', { collection: "Grid" }),
            bindingOptions: {
                visible: 'measurementsClearButtonVisible'
            }
        }
    }

    //#endregion

    private getSelectedType(defaultValue: number = null): number {
        return OperatorLayoutSettings.getSetting(this.$scope.settings.measurmentIdSaveTo + 'measurementsTypeSelected', defaultValue ? defaultValue : 1)
    }

    private setSelectedType(selectedType: number): void {
        OperatorLayoutSettings.setSetting(this.$scope.settings.measurmentIdSaveTo + 'measurementsTypeSelected', selectedType)
    }

    //#region Permissions for chart

    private getChartOptionPermissions(id: number): string[] {
        let result: string[] = []
        switch (id) {
            case DetailsCorrelationFilterType.Location:
                result = [Permissions.LOCATION_MODULE_CHART_OPTION_HIDDEN]
                break
            case DetailsCorrelationFilterType.Device:
                result = [Permissions.DEVICE_MODULE_CHART_OPTION_HIDDEN]
                break
            case DetailsCorrelationFilterType.Meter:
                result = [Permissions.METER_MODULE_CHART_OPTION_HIDDEN]
                break
        }
        return result
    }

    private getChartDataTypeOptionPermissions(id: DetailsCorrelationFilterType): string[] {
        let result: string[] = []
        switch (id) {
            case DetailsCorrelationFilterType.Location:
                result = [Permissions.LOCATION_MODULE_CHART_DATA_TYPE_OPTION_HIDDEN]
                break
            case DetailsCorrelationFilterType.Device:
                result = [Permissions.DEVICE_MODULE_CHART_DATA_TYPE_OPTION_HIDDEN]
                break
            case DetailsCorrelationFilterType.Meter:
                result = [Permissions.METER_MODULE_CHART_DATA_TYPE_OPTION_HIDDEN]
                break
        }
        return result
    }

    //#endregion

    //#region Grid

    private updateGridDimentions(): void {
        if (this.gridDeferred != null) {
            this.gridDeferred.then((grid: dxDataGrid) => {
                grid.updateDimensions()
            })
        }
    }

    private initializeGrid(columns: ColumnModel[], items: RowData[], gridDeferred: JQueryDeferred<dxDataGrid>) {
        if (this.grid != null && this.$scope.gridOptions != null) {
            this.$scope.$broadcast(EventsNames.UPDATE_GRID_DATASOURCE + this.gridId, new DataSource(items))
            gridDeferred.resolve(this.grid)
            return gridDeferred
        }

        this.$scope.gridOptions = {
            name: this.gridDetailsName,
            idReferenceType: Enums.ReferenceType.None,
            type: GridTypes.SMALL,
            buttonsOptions: {
                enabled: true
            },
            dataSource: new DataSource(items),
            addCustomFilters: true,
            columnsDictionary: columns,
            allowColumnReordering: false,
            columnAutoWidth: true,
            columnFixing: { enabled: true },

            onInitialized: (e: any) => {
                this.onGridInitialized(e)
                gridDeferred.resolve(e.component)
            },

            onSelectionChanged: (e: any) => {
                this.onGridSelectionChanges(e)
            }
        }

        return gridDeferred
    }

    private onGridInitialized(e: any): void {
        this.grid = e.component
        this.gridId = e.tableId
    }

    private onGridSelectionChanges(e: any): void {
        this.$scope.showLoadingForChart = true

        if (this.$scope.chartBridge != null) {

            if (e.selectedRowsData.length === 0) {
                this.$scope.chartBridge.data = this.chartData;
            }

            if (e.selectedRowsData.length === 1) {
                let selectedRowKey: any = e.selectedRowsData[0].id
                selectedRowKey = typeof selectedRowKey == 'number' ? selectedRowKey : selectedRowKey.name

                const data: MeasurementModel[] = this.chartData.filter((dataElement: MeasurementModel) => {
                    return (dataElement.idLocation == selectedRowKey || dataElement.serialNbr == selectedRowKey || dataElement.idMeter == selectedRowKey)
                })

                this.$scope.chartBridge.data = data;
            }

            if (e.selectedRowsData.length > 1) {
                const selectedRows: number[] = e.selectedRowsData.map((row: RowData) => row.id);

                const data: MeasurementModel[] = [];
                selectedRows.forEach((selectedRow: number) => {
                    this.chartData.forEach((dataElement: MeasurementModel) => {
                        if (dataElement.idLocation == selectedRow ||
                            dataElement.serialNbr == selectedRow ||
                            dataElement.idMeter == selectedRow) {
                            data.push(dataElement)
                        }
                    })
                })

                this.$scope.chartBridge.data = data
            }

            this.$scope.showLoadingForChart = false
        } else {
            e.component.clearSelection()
        }
    }

    //#endregion

    //#region Chart

    private updateChart(data: MeasureCollection[], measurementsTypes: MeasurementDataType[], fieldId: string, filterId: number, tooltipNames: Tooltip[] = null): void {
        this.$scope.showLoadingForChart = true

        if (tooltipNames == null) {
            tooltipNames = this.$scope.tooltipNames

        }

        this.$scope.chartBridge = null

        this.gridDetailsService
            .setChartType(measurementsTypes)
            .then((updatedMeasurementsTypes: MeasurementDataType[]) => {
                const chartData: { data: MeasurementModel[], types: MeasurementDataType[] } = MeasurementsController.getChartData(this.gridDetailsService.getMeasurementModel(data), updatedMeasurementsTypes, fieldId, tooltipNames)
                this.chartData = chartData.data;
                const types: MeasurementDataType[] = chartData.types
                types.push(...this.thresholdTypes)

                this.$scope.showLoading = false
                this.$scope.showLoadingForChart = false

                this.$scope.chartBridge = {
                    data: chartData.data,
                    selectedTypes: types,
                    filterId: filterId,
                    tickInterval: { hours: 2 },
                    thresholdTypes: this.thresholdTypes,
                    chartOptionsPermissions: this.getChartOptionPermissions(filterId),
                    chartDataTypeOptionsPermissions: this.getChartDataTypeOptionPermissions(filterId)
                }

                this.updateGridDimentions()
            })
            .always(() => {
                this.$scope.showLoadingForChart = false
            })
    }

    //#endregion

    private uniqueFields(arrayFields: ColumnModel[][]): ColumnModel[] {
        const fields: ColumnModel[] = []
        const addedIds: string[] = []

        arrayFields.forEach((df: ColumnModel[]) => {
            df.forEach((f: ColumnModel) => {
                if (addedIds.indexOf(f.name) == -1) {
                    addedIds.push(f.name)
                    fields.push(f)
                }
            })
        })

        return fields
    }

    private setTooltipNames(object: { fields: FieldModel[], id: number, name: string, referenceId: string }): void {
        // toltips for chart
        this.$scope.tooltipNames = [{
            id: [object.id],
            name: object.name
        }]
    }

    //#region Schemas

    /**used in mx-graph for location only  */
    private downloadLocation(): void {
        const currentLanguage: string = this.userSession.getDataProvider().System.getCurrentLanguage();
        this.$scope.schemaOptions.language = currentLanguage.split('-')[0]

        if (this.$scope.settings.referenceType === Enums.ReferenceType.IdLocation &&
            _.size(this.$scope.settings.objects) === 1) {
            this.$scope.schemaOptions.location = this.gridService.getSourceObjectFromGridObject(this.$scope.settings.objects[0], Enums.ReferenceType.IdLocation)
        }

        //#region DPiela doesnt remember what for that request and probably location from gridRow has necessary fields as location from those request. commented request stays here to the ends of tests
        // this.userSession
        //     .getDataProvider()
        //     .Location
        //     .getLocation(this.idReferenceType)
        //     .then((resultOpLocation: OpLocation) => {
        //         this.$scope.schemaOptions.location = resultOpLocation
        //     })
        //#endregion

        this.userSession
            .getDataProvider()
            .Operator
            .getOperatorSettings(this.userSession.getDataProvider().Operator.getLastIdOperator(), [Enums.SimaxOperatorSetting.MxGraphDictionaryRule])
            .then((result: any[]) => {
                if (_.size(result) > 0) {
                    this.$scope.schemaOptions.scripts = result[0];
                }
            })

        this.userSession
            .getDataProvider()
            .DataType
            .getDataTypeDict()
            .then((result: Dictionary<OpDataType>) => {
                this.$scope.schemaOptions.datatypeDict = result;
            })
    }

    private loadSchemas(): void {
        this.$scope.schemaOptions = { location: null, schema: null, schemaModel: null, frameId: null, visualizationOnly: true, language: null, scripts: null, datatypeDict: null }

        if (this.$scope.settings.referenceType === Enums.ReferenceType.IdLocation) {
            /**used in mx-graph for location only  */
            this.downloadLocation()
        }

        this.downloadSchemas()
    }

    private downloadSchemas(): void {
        if (this.idReferenceType != null) {
            this.getSchemasRequest = this.userSession
                .getDataProvider()
                .System
                .getSchema(this.$scope.settings.referenceType, [this.idReferenceType])

            this.getSchemasRequest
                .then((response: OpSchema[]) => {
                    if (response.length > 0) {
                        const schemaCount: number = ConfigHelper.getValue(Enums.SimaxConfigSection.Schema, ConfigHelper.Key.MaxSchemaLimit)

                        if (schemaCount != null) {
                            response = response.slice(0, schemaCount)
                        } else {
                            console.info(GridDetailsService.LOG_PREFIX, "Unable to find schema number limit. Displaying all.")
                        }

                        const simpleXmlSchemas: SchemaModel[] = _.chain(response)
                            .filter((schema: OpSchema) => {
                                return schema.class === Enums.LocationSchemaClass.SimpleXml
                            })
                            .map((schema: OpSchema) => {
                                return CommonHelper.opSchemaToSchemaModel(schema, this.userSession)
                            })
                            .value()

                        const mxGraphSchemas: OpSchema[] = _.filter(response, (schema: OpSchema) => {
                            return schema.class === Enums.LocationSchemaClass.MXGraph
                        })

                        if (_.size(simpleXmlSchemas) > 0) {
                            this.$scope.schemaOptions.schema = null
                            this.$scope.schemas = simpleXmlSchemas

                            if (this.$scope.schemas.length > 1)
                                this.$scope.schemaGalleryOptions = {
                                    items: this.$scope.schemas,
                                    height: '100%',
                                    width: '100%'
                                }
                        } else if (_.size(mxGraphSchemas) > 0) {
                            this.$scope.schemaOptions.schema = ConvertHelper.byteArrayToUnicodeString(<number[]>mxGraphSchemas[0].schema)//atob(CommonHelper.bin2String(<number[]>mxGraphSchemas[0].schema))
                            this.$scope.schemaOptions.schemaModel = CommonHelper.opSchemaToSchemaModel(mxGraphSchemas[0], this.userSession)
                        }
                    }
                })
        }
    }

    //#endregion

    private setBasicParameters(): void {
        this.$scope.detailsParametersOptions = null

        if (_.size(this.$scope.referenceObjects) === 1) {
            const refObj: DetailsReferenceType = this.$scope.referenceObjects[0]

            if (refObj != null) {
                this.gridDetailsService.getReferenceTypeAndValueByReference(refObj)
                    .then((refTypeValue: {
                        referenceType: Enums.ReferenceType,
                        referenceValue: number
                    }) => {
                        this.gridDetailsService
                            .getParametersDataTypeGroup(this.$scope.settings.moduleName, refTypeValue.referenceType, refTypeValue.referenceValue)
                            .then((dataTypeInGroup: OpDataTypeInGroup[]) => {
                                this.$scope.detailsParametersOptions = {
                                    dataTypes: dataTypeInGroup,
                                    referenceType: this.$scope.settings.referenceType,
                                    referenceObject: refObj,
                                    useDynamicValues: true
                                }
                            })
                    })
            }
        }
    }

    private setThresholdColumns(): void {
        this.measurementService
            .getThresholdColumns()
            .then((columns: ColumnModel[]) => {
                this.thresholdTypes = MeasurementsController.getTypesFromColumns(columns)
            })
    }

    private refreshMeasuremets(measurementsTypes: MeasurementDataType[], ids: number[], objForCorrelation: { fields: FieldModel[], id: number, name: string, referenceId: string; }): void {
        const columns: MeasurementDataType[] = []
        columns.push(...measurementsTypes)

        if (_.size(this.thresholdTypes) > 0) {
            this.thresholdTypes.forEach((thrType: MeasurementDataType) => {
                if (!columns.some(t => t.id == thrType.id)) {
                    columns.push(thrType)
                }
            })
        }

        const req: MeasurementsRequestModel = new MeasurementsRequestModel()
        req.columns = <any>columns

        const selectedType: number = this.$scope.measurementsTypeSelected
        let filterId: DetailsCorrelationFilterType = this.$scope.settings.filterId
        let tooltips: Tooltip[] = null
        let fieldId: string = this.$scope.settings.measurmentIdField

        // correlation
        if (objForCorrelation != null && selectedType != null && selectedType != 0 && _.size(this.$scope.settings.measurmentIdsFields) > 0 && this.$scope.settings.measurmentIdsFields[selectedType - 1]) {
            tooltips = []
            filterId = selectedType
            fieldId = this.$scope.settings.measurmentIdFields[selectedType - 1]
            req[this.$scope.settings.measurmentIdsFields[selectedType - 1].fieldIdName] = objForCorrelation[this.$scope.settings.measurmentIdsFields[selectedType - 1].objectName].map((o: { fields: FieldModel[], id: number, name: string, referenceId: string; }) => {
                tooltips.push({
                    id: [o.id],
                    name: o.name
                })
                return o.id
            })

            req.locationIds = [objForCorrelation.id]
        }
        // ---
        else {
            req[this.$scope.settings.measurmentIdsField] = ids
        }

        // date from
        const dateFrom: Date = new Date()
        dateFrom.setHours(0, 0, 0, 0)
        dateFrom.setDate(dateFrom.getDate() - 6)
        const momentFrom: any = moment(dateFrom)
        req.dateFrom = momentFrom.add(momentFrom.utcOffset(), 'minutes').toDate()

        // date to
        const dateTo: Date = new Date()
        dateTo.setHours(23, 59, 59, 999)
        const momentTo = moment(dateTo)
        req.dateTo = momentTo.add(momentTo.utcOffset(), 'minutes').toDate()

        if (req.columns.length != 0) {
            this.getMeasurementsRequest = this.gridDetailsService.getMeasurements(this.$scope.settings.referenceType, req)

            this.getMeasurementsRequest
                .then((data: MeasureCollection[]) => {
                    this.measurementsData = data

                    this.refreshMeasuremetsChart = (data: MeasureCollection[]) => {
                        this.updateChart(data, measurementsTypes, fieldId, filterId, tooltips)
                    }

                    this.refreshMeasuremetsChart(data)
                })
        } else {
            this.measurementsData = []

            this.refreshMeasuremetsChart = (data: MeasureCollection[]) => {
                this.updateChart(data, measurementsTypes, fieldId, filterId, tooltips)
            }

            this.refreshMeasuremetsChart(this.measurementsData)
        }
    }

    private downloadMeasurements(measurementsFields: ColumnModel[], ids: number[], objForCorrelation: { fields: FieldModel[], id: number, name: string, referenceId: string; } = null): void {
        this.$scope.showLoadingForChart = true
        const measurementsTypes: MeasurementDataType[] = MeasurementsController.getTypesFromColumns(measurementsFields || [])

        this.callRefreshMeasuremetsFunction = (measurementsTypes: MeasurementDataType[]) => {
            this.refreshMeasuremets(measurementsTypes, ids, objForCorrelation)
        }

        this.callRefreshMeasuremetsFunction(measurementsTypes)
        this.$scope.measurementsSchemaChangesClearVisible = false
    }

    private generateDetailsGrid(objects: RowData[], ids: number[]): void {
        // grid fields
        this.gridDetailsService
            .getGridDetailsGridColumns(this.$scope.settings.moduleName)
            .then((columns: ColumnModel[]) => {
                this.$scope.tooltipNames = []

                this.initializeGrid(columns, objects, this.gridDeferred)
                    .then(() => {
                        objects.forEach((value: RowData) => {
                            this.$scope.tooltipNames.push({
                                id: [value.id],
                                name: value.name
                            })
                        })

                        this.$scope.showLoading = false

                        // get measurements for chart
                        $.when(...objects.map((o: RowData) => {
                            return this.gridDetailsService.getMeasurementsColumnsByReferenceType(this.gridService.getSourceObjectFromGridObject(o, this.$scope.settings.referenceType))
                        })).then((...measurementsFieldsArray: ColumnModel[][]) => {
                            const measurementFields: ColumnModel[] = this.uniqueFields(measurementsFieldsArray)
                            this.downloadMeasurements(measurementFields, ids)
                        })
                    })
            })
    }

    //#region Corelation

    /**used for location only. select box with location/device/meter for location module */
    private initCorrelation(location: OpLocation): JQueryPromise<void> {
        const deferred: JQueryDeferred<void> = $.Deferred<void>()

        if (_.size(this.$scope.settings.measurmentIdSaveTo) > 0) {
            return this.gridDetailsService
                .getMeasurementsTypeSelectBoxDataSource(location)
                .then((measurementsTypeSelectDataSource: { name: string, type: DetailsCorrelationFilterType, icon: ConfigHelper.Icon }[]) => {
                    if (measurementsTypeSelectDataSource.map(filter => filter.type).indexOf(this.$scope.measurementsTypeSelected) == -1 &&
                        measurementsTypeSelectDataSource[0] != null) {
                        this.$scope.measurementsTypeSelected = measurementsTypeSelectDataSource[0].type
                    }

                    if (measurementsTypeSelectDataSource.length > 1) {
                        this.$scope.measurementsTypeSelected = this.getSelectedType(measurementsTypeSelectDataSource[0].type)

                        if (measurementsTypeSelectDataSource.map(m => m.type).indexOf(this.$scope.measurementsTypeSelected) == -1) {
                            this.$scope.measurementsTypeSelected = measurementsTypeSelectDataSource[0].type
                        }

                        this.$scope.measurementsTypeSelectBoxOptions = {
                            dataSource: measurementsTypeSelectDataSource,
                            valueExpr: 'type',
                            displayExpr: 'name',
                            itemTemplate: (itemData, itemIndex: number, itemElement): void => {
                                this.getMeasurementsTypeSelectBoxItemTemplate(itemData, itemIndex, itemElement)
                            },
                            dropDownButtonTemplate: (): string => {
                                return this.getMeasurementsTypeSelectBoxDropDownButtonTemplate(measurementsTypeSelectDataSource)
                            },
                            onInitialized: (e: any) => {
                                const selectBox: DevExpress.ui.dxSelectBox = e.component

                                setTimeout(() => {
                                    //avoid event while set dataSource
                                    selectBox.option('onSelectionChanged', (e: any) => {
                                        this.onMeasurementsTypeSelectionChanged(e, location)
                                    })
                                })
                            }
                        }
                    } else {
                        this.$scope.measurementsTypeSelectBoxOptions = null
                    }

                    deferred.resolve()
                })
        } else {
            deferred.resolve()
        }

        return deferred.promise()
    }

    private getMeasurementsTypeSelectBoxItemTemplate(itemData, itemIndex: number, itemElement): void {
        const div: JQuery<HTMLElement> = $('<div></div>')
        const name: JQuery<HTMLElement> = $('<div></div>')
        name.append(itemData.name)

        let icon: JQuery<HTMLElement> = $('<div class="drop-down-button-icon" style="width: 20px;">' + TemplateHelper.getIcon(itemData.icon, this.userSession) + '</div>')
        icon = this.$compile(icon)(this.$scope)
        div.append(name)
        div.append(icon)
        div.addClass('drop-down-item')
        itemElement.append(div)
    }

    private getMeasurementsTypeSelectBoxDropDownButtonTemplate(measurementsTypeSelectDataSource: { name: string, type: DetailsCorrelationFilterType, icon: ConfigHelper.Icon }[]): string {
        const selectedItem: { name: string, type: DetailsCorrelationFilterType, icon: ConfigHelper.Icon } = _.find(measurementsTypeSelectDataSource, x => x.type == this.$scope.measurementsTypeSelected)
        const ddb: string = '<div class="drop-down-button-icon">' + TemplateHelper.getIcon(selectedItem.icon, this.userSession) + '</div>'
        return ddb
    }

    private onMeasurementsTypeSelectionChanged(e: any, location: OpLocation): void {
        this.$scope.measurementsTypeSelected = e.selectedItem.type
        this.setSelectedType(this.$scope.measurementsTypeSelected)

        if (this.callRefreshMeasuremetsFunction != null) {
            this.$scope.showLoadingForChart = true
            let objects: DetailsReferenceType[] = []

            if (this.$scope.measurementsTypeSelected == DetailsCorrelationFilterType.Location) {
                objects = [location]
            } else if (this.$scope.measurementsTypeSelected == DetailsCorrelationFilterType.Device) {
                objects = location.currentDevices
            } else if (this.$scope.measurementsTypeSelected == DetailsCorrelationFilterType.Meter) {
                objects = location.currentMeters
            }

            $.when(...objects.map((o: DetailsReferenceType) => {
                return this.gridDetailsService.getMeasurementsColumnsByReferenceType(o)
            }))
                .then((...measurementsFieldsArray: ColumnModel[][]) => {
                    const measurementFields: ColumnModel[] = this.uniqueFields(measurementsFieldsArray)
                    const measurementsTypes: MeasurementDataType[] = MeasurementsController.getTypesFromColumns(measurementFields)

                    this.callRefreshMeasuremetsFunction(measurementsTypes)
                })

            this.$scope.measurementsSchemaChangesClearVisible = false
        }
    }

    //#endregion

    private generateDetailsWithMeasurements(idReferenceType: number): void {
        this.$scope.schemas = []
        this.$scope.schemaGalleryOptions = null

        this.getReferenceObjectRequest = this.gridDetailsService.getReferenceObject(this.$scope.settings.referenceType, idReferenceType)

        this.getReferenceObjectRequest
            .then((reference: DetailsReferenceType) => {
                this.$scope.referenceObjects = [reference]
                this.setBasicParameters()

                this.gridDetailsService
                    .referenceObjectIntoModel(reference)
                    .then((object: { fields: FieldModel[], id: number, name: string, referenceId: string; }) => {
                        // schema
                        this.idReferenceType = object.id
                        this.$scope.schemaOwner = object

                        this.loadSchemas()
                        // end of schema

                        //#region Corelation
                        /**IReferenceType should be */
                        let objForCorrelation: { fields: FieldModel[], id: number, name: string, referenceId: string; } = null

                        const deferred: JQueryDeferred<ColumnModel[]> = $.Deferred<ColumnModel[]>()

                        if (this.$scope.settings.referenceType === Enums.ReferenceType.IdLocation) {
                            objForCorrelation = object
                            const location: OpLocation = <OpLocation>reference

                            this.initCorrelation(location)
                                .then(() => {
                                    let objects: DetailsReferenceType[] = []

                                    if (this.$scope.measurementsTypeSelected == DetailsCorrelationFilterType.Location) {
                                        objects = [location]
                                    } else if (this.$scope.measurementsTypeSelected == DetailsCorrelationFilterType.Device) {
                                        objects = location.currentDevices
                                    } else if (this.$scope.measurementsTypeSelected == DetailsCorrelationFilterType.Meter) {
                                        objects = location.currentMeters
                                    }

                                    $.when(...objects.map((o: DetailsReferenceType) => {
                                        return this.gridDetailsService.getMeasurementsColumnsByReferenceType(o)
                                    }))
                                        .then((...measurementsFieldsArray: ColumnModel[][]) => {
                                            const measurementFields: ColumnModel[] = this.uniqueFields(measurementsFieldsArray)

                                            deferred.resolve(measurementFields)
                                        })
                                })
                        } else {
                            this.gridDetailsService
                                .getMeasurementsColumnsByReferenceType(reference)
                                .then((columns: ColumnModel[]) => {
                                    deferred.resolve(columns)
                                })
                        }
                        //#endregion

                        deferred.promise()
                            .then((columns: ColumnModel[]) => {
                                _.forEach(columns, (column: ColumnModel) => column.chartType = 'line')
                                this.downloadMeasurements(columns, [idReferenceType], objForCorrelation)
                            })

                        this.setTooltipNames(object)

                        this.refreshEvent = this.$scope.$on(EventsNames.CLOSE_CREATE_EDIT_POPUP, (event: ng.IAngularEvent, ...args: any[]) => {
                            if (_.size(args) > 0) {
                                const updated: { fields: FieldModel[], id: number, name: string, referenceId: string; } = args[0]

                                if (updated.id == object.id) {
                                    this.setTooltipNames(updated)
                                }
                            }
                        })

                        return object
                    })
            })
    }

    private updateDetails(objects: RowData[]): void {
        if (this.refreshEvent != null) {
            this.refreshEvent()
            this.refreshEvent = null
        }

        this.setBasicParameters()

        this.$scope.showLoading = true

        if (this.updateDetailsTimeout != null) {
            clearTimeout(this.updateDetailsTimeout)
        }

        this.updateDetailsTimeout = setTimeout(() => {
            if (_.size(objects) === 0) {
                return
            }

            this.$scope.$root.$broadcast('disableLoadingIndicator')
            this.$scope.measurementsTypeSelectBoxOptions = null
            this.refreshMeasuremetsChart = null
            this.idReferenceType = null
            this.$scope.measurementsSchemaChangesClearVisible = false
            this.gridDeferred = $.Deferred<DevExpress.ui.dxDataGrid>()

            setTimeout(() => {
                const ids: number[] = objects.map((o: RowData) => o.id)

                if (ids.length > 1) {
                    this.generateDetailsGrid(objects, ids)
                } else if (ids.length == 1) {
                    this.generateDetailsWithMeasurements(ids[0])
                }
            }, 0)
        }, 500)
    }

    private refresh(): void {
        const objects: RowData[] = this.$scope.settings.objects

        if (_.size(objects) > 0) {
            this.lastIds = objects.map((obj: RowData) => obj.id)

            if (this.getReferenceObjectRequest != null) {
                this.getReferenceObjectRequest.cancel()
            }

            if (this.getSchemasRequest != null) {
                this.getSchemasRequest.cancel()
            }

            if (this.getMeasurementsRequest != null) {
                this.getMeasurementsRequest.cancel()
            }

            this.updateDetails(objects)
        }
    }

    private setTemplateConsts(): void {
        if (_.size(this.$scope.settings.noDataText) > 0) {
            this.$scope.NO_DATA_TEXT = this.$scope.settings.noDataText
        } else {
            this.$scope.NO_DATA_TEXT = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SelectRowToShowDetails)
        }

        this.$scope.NO_DATA_TO_SHOW_TEXT = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoDataToShow)
    }

    //#endregion
}